/**
 * Query key factory for the shared right rail.
 *
 * Its own root — `['market-rail']` — rather than a branch of `marketKeys`
 * (`['market']`) or of `marketOverviewKeys` (`['market-overview']`). TanStack
 * Query invalidates by prefix, and the rail is mounted on every signed-in
 * screen: hanging it under `marketKeys.all` would mean the NEPSE card's own
 * refresh button silently re-fetched the rail of whatever screen it sits on
 * too. Nesting it under Market Overview would be worse still — the rail
 * outlives that screen by six routes.
 *
 * Note what is NOT here. `market-now` and `popular-stocks` reuse
 * `marketKeys.indexSummary('live','NEPSE')` and `watchlistKeys.popular()`
 * verbatim through their existing hooks, so the rail shares those entries with
 * Home and Market Overview instead of minting parallel ones, and the mood
 * reads `marketKeys.mood()` the same way. Only the blocks with no hook of
 * their own get keys here.
 */
export const marketRailKeys = {
  all: ['market-rail'] as const,
  updates: () => [...marketRailKeys.all, 'updates'] as const,
  commodities: () => [...marketRailKeys.all, 'commodities'] as const,
  shareUnlocks: () => [...marketRailKeys.all, 'share-unlocks'] as const,
  topMovers: () => [...marketRailKeys.all, 'top-movers'] as const,
  yearRange: () => [...marketRailKeys.all, 'year-range'] as const,
}
